// extracted by mini-css-extract-plugin
module.exports = {"specsContainer":"CarsPage_specsContainer__JJwah"};